
import states from '@/services/states.json';

export interface State {
	[key: string]: string;

	/**
	 * Full name of state or territory
	 * @example "Oklahoma"
	 * @example "Armed Forces Pacific"
	 * @example "Palau"
	 */
	name: string;

	/**
	 * Abbreviation of state or territory
	 * @example "OK"
	 * @example "AP"
	 * @example "PW"
	 */
	code: string;
}

export class StateService {
	findAll(): Promise<Array<State>> {
		return new Promise((resolve) => {
			resolve(states);
		});
	}
	find(code = ''): Promise<State> {
		return new Promise((resolve, reject) => {
			let i;
			const ilen = states.length;
			const codeMatch = (code || '').toUpperCase();
			for (i = 0; i < ilen; i++) {
				if (codeMatch === states[i].code) {
					resolve(states[i]);
					return;
				}
				reject('Not found');
			}
		});
	}
}

